import React, { createContext } from 'react';
export var ConfigContext = createContext({
    prefixCls: 'i18n-ecom-alliance',
    baseLibrary: 'arco',
});
var ConfigProvider = function (props) {
    var children = props.children;
    return React.createElement(ConfigContext.Provider, { value: props }, children);
};
export function useConfigContext() {
    return React.useContext(ConfigContext);
}
export default ConfigProvider;
//# sourceMappingURL=index.js.map